/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Label } from "@cars24/turbo-web/lib/label";
import { NUMBER } from "../../../constants/app-constants";
import { Badge } from "@cars24/turbo-web/lib/badge";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { Button } from "@cars24/turbo-web/lib/button";
import BadgeIcon from "./images/badge.svg";
import Car from "./images/car.svg";
import User from "./images/user.svg";
import CarUser from "./images/car-user.svg";
import { getCarHealthDetails, getHeaderText } from "./selector";
import {
    HEADING_REPORT_DETAILS,
    REPORT_STATUS } from "./constant";
import Download from "./images/download.svg";
import styles from "./styles.css";
import Info from "./images/info.svg";
import Tick from "./images/tick.svg";
import { appUrl, vasIndiaWebsiteUrl } from "../../../constants/url-constants";
import { Divider } from "@cars24/turbo-web/lib/divider";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { CHR_REPORT_TYPES } from "../../../constants/c2b-vas-constants";
import { ArrowIcon } from "@cars24/turbo-web/lib/icons/arrow-icon";

const PostInspectionDiyCarInspection = ({
    rating: details = [],
    // amount,
    status = REPORT_STATUS.NOT_FOUND,
    // getReportUrlConnect,
    reportToken,
    reportType = "",
    history,
    inspectionResponse,
    resetCarHealthConnect
}) => {
    const { tokens } = useTokens();
    const { leadToken, customerName } = inspectionResponse || {};
    const carHealthURL = `${appUrl()}/car-health/${leadToken}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const reportDetails = useMemo(() => getCarHealthDetails(details), []);
    const { heading = "", subHeading = "" } = HEADING_REPORT_DETAILS[status] || {};
    const isNotBought = status === REPORT_STATUS.NOT_BOUGHT;
    const isReportInApp = reportType === CHR_REPORT_TYPES.CAR_HEALTH_REPORT_IN_APP;

    const handleClick = (token) => {
        if (isNotBought) window.open(carHealthURL, "_blank");
        else {
            resetCarHealthConnect();

            if (isReportInApp) {
                window.location.href = `${vasIndiaWebsiteUrl()}/car-health-report/${reportToken}`;
            }
            history.push(`/seller-vas-report-download/${token}`);
            // getReportUrlConnect(reportToken).then(res => {
            //     window.open(res.reportUrl, "_blank");
            // });
        }
    };

    const getColor = (rating) => {
        if (parseFloat(rating) >= NUMBER.FOUR) return tokens.text_state_text_success;
        if (parseFloat(rating) < NUMBER.FOUR && parseFloat(rating) >= NUMBER.TWO) return tokens.text_state_text_warning;
        else return tokens.text_state_text_error;
    };

    return (<>
        <div styleName={"styles.carHealthWrapper"}>
            {isNotBought &&
                    <div styleName={"styles.verifiedWrapper"}>
                        <div styleName={"styles.verified"}>
                            <img src={BadgeIcon} alt="badge" />
                            <Label level={NUMBER.FOUR} fontWeight="regular">Get your CARS24 verified</Label>
                        </div>
                        <Badge
                            icon={<img src={Car} alt="car" />}
                            label="RECOMMENDED"
                            type="dark"
                            variant="success"
                        />
                    </div>}
            <div styleName={"styles.reportHeading"}>
                <Heading level={NUMBER.THREE} isBold>{heading}</Heading>
                {status !== REPORT_STATUS.NOT_FOUND && status !== REPORT_STATUS.NOT_BOUGHT && <img src={ status === REPORT_STATUS.BOUGHT ? Tick : Info } alt="info" />}
            </div>
            <Label level={NUMBER.FOUR} fontWeight="regular">{subHeading}</Label>
            <div styleName={"styles.userCarWrapper"}>
                <div styleName={"styles.carUser"}>
                    <img src={User} alt="user_img" />
                    <Label level={NUMBER.FOUR} >{customerName}</Label>
                </div>
                <div styleName={"styles.carUser"}>
                    <img src={CarUser} alt="user_img" />
                    <Label level={NUMBER.FOUR} >{ getHeaderText(inspectionResponse) }</Label>
                </div>
            </div>
            <div styleName={"styles.divider"}>
                <Divider variant="primary" />
            </div>

            <Label level={NUMBER.TWO} fontWeight="medium">Here’s a brief review of your report</Label>
            <div styleName={"styles.userCardWrapper"}>
                {
                    reportDetails && !!reportDetails.length && reportDetails.map(({ label, icon, rating }, index) => (
                        <div key={`car-health-details-${index}`} styleName={"styles.cardWrapper"}>
                            <div styleName={"styles.carUser"}>
                                <img src={icon} alt={`car-health-details-img-${index}`} />
                                <Label level={NUMBER.FOUR}>{label}</Label>
                            </div>
                            <Label color={getColor(rating)} level={NUMBER.THREE} fontWeight="semibold">{rating}</Label>
                        </div>
                    ))
                }
            </div>
            {status && status !== REPORT_STATUS.NOT_FOUND && status !== REPORT_STATUS.PENDING && !isNotBought &&
                <div styleName={"styles.reportDownloadCta"}>
                    {/* {isNotBought && <Label level={NUMBER.TWO} color={tokens.text_brand_text_brand} fontWeight="semibold">To unlock the full report </Label>} */}
                    <Button
                        label={
                            isReportInApp
                                ? "View report"
                                : "Download report"
                        }
                        onClick={() => {handleClick(reportToken);}}
                        size="large"
                        variant="primary"
                        suffixIcon={
                            isReportInApp
                                ? <ArrowIcon size="16px" fill={"#FFFFFF"} />
                                : <img src={Download} alt="download" />
                        }
                    />
                </div>
            }
        </div>
    </>

    );
};

PostInspectionDiyCarInspection.propTypes = {
    carDetails: PropTypes.object,
    rating: PropTypes.object,
    amount: PropTypes.string,
    status: PropTypes.string,
    leadToken: PropTypes.string,
    // getReportUrlConnect: PropTypes.func,
    reportToken: PropTypes.string,
    history: PropTypes.object,
    inspectionResponse: PropTypes.object,
    resetCarHealthConnect: PropTypes.func,
    secureToken: PropTypes.string,
    mobile: PropTypes.string,
    createOrderConenect: PropTypes.func,
    fetchSellerPackageDataConnect: PropTypes.func,
    reportType: PropTypes.string
};

export default PostInspectionDiyCarInspection;
